import { Constant } from "../apiConstants";

const GeneralEnquiryAPI = async (formdata) => {

  const token = sessionStorage.getItem("token");

  const HttpHeaders = {
    Accept: "*/*",
    Authorization: "Bearer " + token,
  };

  const endpoint = Constant.POST_QUERIES;
  const BaseUrl = Constant.BASE_URL;
  try {
    const response = await fetch(BaseUrl + "/" + endpoint, {
      method: "post",
      headers: HttpHeaders,
      body: formdata,
    });
    const responseData = await response.json();
    return responseData;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export default GeneralEnquiryAPI;
